import React, { useState } from 'react'
import { Card, Space, Button } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFlask, faList, faPlus, faClipboardList, faChartLine, faClock } from '@fortawesome/free-solid-svg-icons'
import PageHeader from '../../reusable-components/PageHeader'
import OrdersList from './OrdersList'
import NewOrder from './NewOrder'
import Analytics from './Analytics'
import PendingResults from './PendingResults'
import OrderDetail from './OrderDetail'

const LabOrdersWrapper = () => {
  const [activeView, setActiveView] = useState('orders')
  const [selectedOrder, setSelectedOrder] = useState(null)
  const [persistedFormData, setPersistedFormData] = useState(null)

  const handleOrderSelect = (order) => {
    setSelectedOrder(order)
    setActiveView('detail')
  }

  const handleBackToList = () => {
    setSelectedOrder(null)
    setActiveView('orders')
  }

  const handleFormDataPersist = (formData) => {
    setPersistedFormData(formData)
  }

  const handleOrderComplete = () => {
    setPersistedFormData(null) // Clear persisted data after successful submission
    handleBackToList()
  }

  const renderContent = () => {
    switch (activeView) {
      case 'orders':
        return <OrdersList onOrderSelect={handleOrderSelect} />
      case 'new':
        return (
          <NewOrder
            onComplete={handleOrderComplete}
            onFormDataChange={handleFormDataPersist}
            initialFormData={persistedFormData}
          />
        )
      case 'analytics':
        return <Analytics />
      // case 'pending':
      //   return <PendingResults onOrderSelect={handleOrderSelect} />
      case 'detail':
        return <OrderDetail order={selectedOrder} onBack={handleBackToList} />
      default:
        return <OrdersList onOrderSelect={handleOrderSelect} />
    }
  }

  const tabOptions = [
    { key: 'orders', icon: faList, label: 'All Orders' },
    { key: 'new', icon: faPlus, label: 'New Order' },
    // { key: 'pending', icon: faClock, label: 'Pending Results' },
    { key: 'analytics', icon: faChartLine, label: 'Analytics' }
  ]

  return (
    <>
      {/* Header Section */}
      <div style={{ marginTop: '16px' }}>
        <PageHeader title='Lab Orders Management' icon={faFlask} />
      </div>

      <div style={{ padding: '16px 24px' }}>
        {activeView !== 'detail' && (
          <div
            style={{
              marginBottom: 24,
              display: 'flex',
              gap: '8px',
              backgroundColor: '#ffffff',
              padding: '8px',
              borderRadius: '12px',
              border: '1px solid #e6f4ff',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)'
            }}
          >
            {tabOptions.map((tab) => (
              <Button
                key={tab.key}
                type={activeView === tab.key ? 'primary' : 'text'}
                size='large'
                icon={<FontAwesomeIcon icon={tab.icon} />}
                onClick={() => setActiveView(tab.key)}
                style={{
                  flex: 1,
                  height: '48px',
                  borderRadius: '8px',
                  border: activeView === tab.key ? 'none' : '1px solid #d9d9d9',
                  fontWeight: activeView === tab.key ? '600' : '500',
                  backgroundColor: activeView === tab.key ? '#1890ff' : '#ffffff',
                  color: activeView === tab.key ? '#ffffff' : '#262626',
                  boxShadow:
                    activeView === tab.key ? '0 2px 4px rgba(24, 144, 255, 0.3)' : '0 1px 2px rgba(0, 0, 0, 0.05)',
                  transition: 'all 0.2s ease',
                  margin: '0 2px'
                }}
              >
                {tab.label}
              </Button>
            ))}
          </div>
        )}

        <div style={{ height: 'calc(100vh - 200px)' }}>{renderContent()}</div>
      </div>
    </>
  )
}

export default LabOrdersWrapper
